import React from 'react'

import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import PageRoutes from '@utils/page-routes'

const MusicSection: React.FC = () => {
  const { t } = useTranslation()
  return (
    <ul className="p-2.5 basis-1/2 sm:basis-[auto]">
      <li className="font-medium text-md mb-0.5">{t('footer.music.title')}</li>
      <li className="py-0.5">
        <Link to={PageRoutes.musicPath()} className="link">
          {t('footer.music.community')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.musicCategoriesPath()} className="link">
          {t('footer.music.browseCategories')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.musicSongCatalogPath()} className="link" reloadDocument>
          {t('footer.music.songCatalog')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.musicPurchasingGuidePath()} className="link" reloadDocument>
          {t('footer.music.purchasing')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.musicSellingGuidePath()} className="link" reloadDocument>
          {t('footer.music.selling')}
        </Link>
      </li>
    </ul>
  )
}

export default MusicSection
